
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { User } from '@/types';

@Component
export default class PermissionsInfo extends Vue {
  @Prop({ type: String, default: 'mdi-account-cog' }) readonly icon!: string
  @Prop({ type: String, default: 'accent' }) readonly color!: string

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get isSuperUser() {
    return this.user && this.user.isSuperUser;
  }
}
